export default class Sample {
  constructor({ x, y, progress, segment }) {
    this.x = x;
    this.y = y;
    this.progress = progress;
    this.segment = segment;
  }
}
